import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { size, trimEnd } from 'lodash';
import { prettifyNumber } from '@nexio/emvio-util-app';

import Widget from '../Widget/Widget';

import './ApproveDeclineWidget.scss';

export default class ApproveDeclineWidget extends Component {
    static propTypes = {
        hasTransactionsFromYesterday: PropTypes.bool,
        yesterdayApprovalPercentage: PropTypes.number,
        yesterdayVsLastThirtyApprovalPercentage: PropTypes.number,
        topDeclineReasons: PropTypes.array
    };

    static defaultProps = {
        topDeclineReasons: []
    };

    renderTopDeclineReasons(data) {
        const { topDeclineReasons } = this.props;

        let body;
        if  (size(topDeclineReasons)) {
            body = topDeclineReasons.map((reason) => {
                return reason.message ?
                    <div key={reason.message} className="decline-reason">
                        <span className="message">{trimEnd(reason.message, '.')}</span>
                        <span className="message-count">{prettifyNumber(reason.count)}</span>
                    </div>
                    : null;
            });
        }  else {
            body = <div className="declines-no-data">--</div>;
        }

        return (
            <Fragment>
                <div className="widget-heading">{data.title}</div>
                {body}
            </Fragment>
        );
    }

    renderApprovalPercentage(data) {
        return (
            <Fragment>
                <div className="widget-heading">{data.title}</div>
                <div className="widget-value">{data.value}</div>
                <div className="widget-delta">
                    <span className="material-icons">
                        {data.deltaDirection === 'up' ? 'arrow_drop_up' : 'arrow_drop_down'}
                    </span>
                    {data.deltaText}
                </div>
            </Fragment>
        );
    }

    render() {
        const {
            yesterdayApprovalPercentage,
            hasTransactionsFromYesterday
        } = this.props;

        const approvalPercentage = {
            title: 'Yesterday\'s Approval Percentage',
            value: hasTransactionsFromYesterday && yesterdayApprovalPercentage ? `${prettifyNumber(this.props.yesterdayApprovalPercentage)}%` : '--',
            deltaText: `${prettifyNumber(Math.abs(this.props.yesterdayVsLastThirtyApprovalPercentage), 0, 1)}% from last 30 days`,
            deltaDirection: this.props.yesterdayVsLastThirtyApprovalPercentage < 0 ? 'down' : 'up'
        };

        const topDeclines = {
            title: 'Last 30 Days Top Decline Reasons'
        };

        return (
            <div className="approve-decline-card widget-layout">
                <div className="widget-title">
                    Approvals & Declines
                </div>
                <Widget
                    left={this.renderApprovalPercentage(approvalPercentage)}
                    right={this.renderTopDeclineReasons(topDeclines)}
                    variant="light"
                />
            </div >
        );
    }
}
